import type { Timestamp } from "@bufbuild/protobuf";

const formatJst = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
})

export const formatTimestampJaJst = (
  timestamp: Timestamp,
  options?: { withTime?: boolean }
): string => {
  return formatDateJaJst(timestamp.toDate(), options);
};

export const formatTimestampIsoJst = (
  timestamp: Timestamp,
  options?: { withTime?: boolean }
): string => {
  return formatDateIsoJst(timestamp.toDate(), options);
};

export const formatDateJaJst = (
  date: Date,
  options?: { withTime?: boolean }
): string => {
  const parts = formatJst.formatToParts(date);
  const year = parts.find(part => part.type === "year")?.value;
  const month = parts.find(part => part.type === "month")?.value;
  const day = parts.find(part => part.type === "day")?.value;
  if (options?.withTime) {
    const hour = parts.find(part => part.type === "hour")?.value;
    const minute = parts.find(part => part.type === "minute")?.value;
    const second = parts.find(part => part.type === "second")?.value;
    return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
  }
  return `${year}年${month}月${day}日`;
};

export const formatDateIsoJst = (
  date: Date,
  options?: { withTime?: boolean }
): string => {
  const parts = formatJst.formatToParts(date);
  const year = parts.find(part => part.type === "year")?.value;
  const month = parts.find(part => part.type === "month")?.value;
  const day = parts.find(part => part.type === "day")?.value;
  if (options?.withTime) {
    const hour = parts.find(part => part.type === "hour")?.value;
    const minute = parts.find(part => part.type === "minute")?.value;
    const second = parts.find(part => part.type === "second")?.value;
    return `${year}-${month}-${day}T${hour}:${minute}:${second}+09:00`;
  }
  return `${year}-${month}-${day}`;
}
